import {applySnapshot, types} from 'mobx-state-tree';
import get from 'lodash/get';
import {rootStore} from '.';
import UserService from 'services/UserService';
import AttendService from 'services/AttendService';
import GroupService from 'services/GroupService';

export const AnnuaLeavePlan = types
    .model('AnnuaLeavePlan', {
        year: types.optional(types.number, new Date().getFullYear()),
        month: types.optional(types.number, new Date().getMonth() + 1),
        days: types.optional(types.array(types.frozen()), []),
        datas: types.optional(types.array(types.frozen()), []),
        selectedDataList: types.optional(types.array(types.frozen()), []),
        approvalLines: types.optional(types.array(types.frozen()), []),
        yearParams: types.optional(types.frozen({
            startDate: types.string,
            endDate: types.string
        }), {
            startDate: '',
            endDate: ''
        }),
    })
    .views((self) => ({
        get get() {
            try {
                return { ...self };
            } catch (err) {
                console.error(err);
                return err;
            }
        },
    }))
    .actions((self) => ({
        reset() {
            console.log('RESET MOBX MODEL')
            applySnapshot(self, {});
        },
        setSelectedDataList(data) {
            self.selectedDataList = data;
        },
        setApprovalLines(values = []) {
            self.approvalLines = values;
        },
        setYearParams(values = []) {
            self.yearParams = values;
        },
        async getApprovalLine() {
            const { company, user } = rootStore;
            const companyId = company.get.id;
            const departId = get(company, 'departInfos[0].departId', '');

            const userId = user.me.id;
            const res = await UserService.getApproval(companyId, { userId, departId: departId, option: 'up' });
            self.setApprovalLines(res?.data);
            return res?.data;
        },
        async requestLeave(data) {
            const { cb, ...rest } = data;
            const companyId = rootStore?.company.get.id;
            const userId = rootStore.user.me.id;
            const group = await GroupService.getGroupInfoById(userId, companyId);
            const res = await AttendService.annualLeaveRequest({
                ...rest,
                companyId,
                type: "USER_REST",
                startDate: self.yearParams.startDate,
                endDate: self.yearParams.endDate,
                areaId: get(group, 'data.areaId', null),
                isApproval: {}
            });

            const message = res?.result ? null : (res?.data?.message || 'annualLeavePlan.requestError');
            cb?.(res?.result ?? false, message?.replace(/\\n/g, '\n'));
        }
    }));

export default AnnuaLeavePlan;
